import React from 'react';
import { Segment, Table, Header, Icon, Popup } from 'semantic-ui-react';
import { IconHeader } from '../util/css';
import { getLeaseholderName } from '../util/util';

export default class LeasesDetail extends React.Component {
    render() {
        const { lease } = this.props;
        return (
            <div>
                <Header as="h1">Zakupi</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Detalji o zakupu
                            <Header style={IconHeader} floated="right">
                                <Icon/>
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left"
                                                   onClick={this.props.switchToTable}/>}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>
                        <Table celled>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Članica</b></Table.Cell>
                                    <Table.Cell>{lease.leaseholder.organizationalUnit.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Predmet zakupa</b></Table.Cell>
                                    <Table.Cell>{lease.leaseSubject}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Zakupac - Tip zakupca</b></Table.Cell>
                                    <Table.Cell>{getLeaseholderName(lease.leaseholder)}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Namjena zakupa</b></Table.Cell>
                                    <Table.Cell>{lease.purpose}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Napomena</b></Table.Cell>
                                    <Table.Cell>{lease.comment}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Početak zakupa</b></Table.Cell>
                                    <Table.Cell>{!!lease.beginDate && lease.beginDate.getDate()}. {!!lease.beginDate && lease.beginDate.getMonth() + 1}. {!!lease.beginDate && lease.beginDate.getFullYear()}.</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Istek zakupa</b></Table.Cell>
                                    <Table.Cell>{!!lease.endDate && lease.endDate.getDate()}. {!!lease.endDate && lease.endDate.getMonth() + 1}. {!!lease.endDate && lease.endDate.getFullYear()}.</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Mjesečni prihodi (BAM)</b></Table.Cell>
                                    <Table.Cell>{lease.incomePerMonth}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>

                        {lease.legalDocument ?
                            <React.Fragment>
                                <Header as="h3">Pravni dokument</Header>
                                <Table celled>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell textAlign="right"><b>Tip pravnog dokumenta</b></Table.Cell>
                                            <Table.Cell>{lease.legalDocument.legalDocumentType.name}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign="right"><b>Datum izdavanja pravnog
                                                dokumenta</b></Table.Cell>
                                            <Table.Cell>{!!lease.legalDocument.date && (new Date(lease.legalDocument.date)).getDate()}. {!!lease.legalDocument.date && (new Date(lease.legalDocument.date)).getMonth() + 1}. {!!lease.legalDocument.date && (new Date(lease.legalDocument.date)).getFullYear()}.</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign="right"><b>Broj pravnog dokumenta</b></Table.Cell>
                                            <Table.Cell>{lease.legalDocument.documentNumber}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell textAlign="right"><b>Napomena</b></Table.Cell>
                                            <Table.Cell>{lease.legalDocument.comment}</Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </React.Fragment> :
                            <React.Fragment>
                                <Header as="h3">Pravni dokument</Header>
                                <Table celled>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell textAlign="center">Ovaj zakup nema pravni dokument</Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </React.Fragment>
                        }
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leases/LeasesDetails.js